module.exports = __webpack_public_path__ + "img/00034.34b34432.webp";